import { render, staticRenderFns } from "./LayoutUnknown.vue?vue&type=template&id=4b81e4c7&scoped=true&"
import script from "./LayoutUnknown.vue?vue&type=script&lang=ts&"
export * from "./LayoutUnknown.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutUnknown.vue?vue&type=style&index=0&id=4b81e4c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81e4c7",
  null
  
)

export default component.exports